import {ComponentDetailsNewController} from './components_details_new.controller';

function componentDetailsNewConfig($stateProvider) {

    $stateProvider
        .state('components.details', {
            url: '/component/details/{componentID}/{componentVersion}',
            parent: 'app-layout',
            template: require('./components_details_new.html'),
            controller: 'ComponentDetailsNewController as componentDetailsNew',
            params: {
                title: 'Component Details',
                componentVersion: {value: null, squash: true}
            }
        })
}

export default angular.module('componentDetailsNew', [])
    .config(componentDetailsNewConfig)
    .controller('ComponentDetailsNewController', ComponentDetailsNewController)




// WEBPACK FOOTER //
// ./modules/xray/states/components_new/components_details_new.module.js